import React, { useRef, useState } from "react";
import { Alert, Button, Card, Container, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ForgotPassword() {
  const emailRef = useRef();
  const { resetPassword } = useAuth();
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setMessage("");
      setError("");
      setLoading(true);
      await resetPassword(emailRef.current.value);
      setMessage(
        "Wir haben dir eine Email zum Zurücksetzen deines Passworts geschickt."
      );
      setLoading(false);
    } catch (e) {
      console.log(e.message);
      setError("Passwort zurücksetzen fehlgeschlagen!");
      setLoading(false);
    }
  }

  return (
    <Container
      className="align-items-center justify-content-center"
      style={{
        maxWidth: "700px",
        minWidth: "300px",
        padding: "100px 50px",
      }}
    >
      <Card>
        <Card.Body>
          <h2 className="text-center mb-3">Passwort vergessen?</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          {message && <Alert variant="success">{message}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email" className="w-100 mb-4">
              <Form.Label>E-Mail</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <Button disabled={loading} className="w-100 mb-3" type="submit">
              Passwort zurücksetzen
            </Button>
          </Form>
          <div className="w-100 text-center">
            <Link to="/login">Anmelden</Link>
          </div>
        </Card.Body>
      </Card>
      <div className="w-100 text-center mt-2">
        Kein Konto? <Link to="/sign-up">Registrieren</Link>
      </div>
    </Container>
  );
}
